import * as messaging from 'firebase/messaging'

import api from 'browser/app/models/apis'
import { getBrowserVersion } from 'browser/app/utils/utils'

const DEVICE_ENTITY_TYPE = '/1.0/entities/metadata/device.json'

export const requestFirebaseNotificationPermission = async () => {
  if (!(await messaging.isSupported())) {
    return
  }

  return Notification.requestPermission()
    .then(() => {
      const m = messaging.getMessaging()
      const token = messaging.getToken(m, {
        vapidKey:
          'BPX6b7dQl0qCkPon-cyfq5UCAQ_HnmMTLLiypgGHJOjMvc0os61UwwKq4oZ2kI3RbKiY-ZWMQVUZJ4Kq7UYpyNU',
      })
      messaging.onMessage(m, (noti) => {
        // firebase only shows notifications to backgrounded tabs
        // foregrounded needs duplicate handling by the app code
        // https://groups.google.com/g/firebase-talk/c/YpREmlSiCtY
        // https://firebase.google.com/docs/cloud-messaging/js/receive
        const notification = new Notification(noti.data.title, {
          body: noti.data.message,
          icon: noti.data.icon,
        })
        notification.onclick = (event) => {
          window.open(noti.data.uri)
        }
      })
      return token
    })
    .then((firebaseToken) => {
      registerDevice(firebaseToken)
      return firebaseToken
    })
    .catch((err) => {
      console.log(`Unable to get permission to notify: ${err.message}`)
    })
}

export const registerDevice = (deviceToken: string) => {
  const store: any = api.getStore()
  const metadata = store.getRecord(DEVICE_ENTITY_TYPE)
  const deviceEntity = store.createRecord(metadata, {
    device: {
      identifier: deviceToken,
      platform: 'web',
      product: getBrowserVersion(),
      appVersion: 'browser',
    },
  })

  deviceEntity
    .save({ useOfflineQueue: false })
    .then((data) => {
      // silently do nothing
    })
    .catch((err) => {
      // silently do nothing
    })
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage(messaging.getMessaging(), (payload) => {
      resolve(payload)
    })
  })
